import { zergApi } from "@/service/zerg";

class GeneralSettingPayrollService {
    async getPayrollGeneralSettings() {
        try {
            const data = await zergApi.get('setting/payroll/general/get-general-settings');
            return data;
        } catch (error) {
            throw error;
        }
    }

    async updatePayrollGeneralSettings(data) {
        try {
            const response = await zergApi.post('setting/payroll/general/update-general-settings', data);
            return response;
        } catch (error) {
            throw error;
        }
    }

}

export default new GeneralSettingPayrollService();